import { forwardRef, type HTMLAttributes } from 'react';

import { cn } from '../../../../../utils';
import { useIsReorderableRegion } from '../../../contexts/is-reorderable-region.context';

export const DataGridCellContent = forwardRef<
  HTMLDivElement,
  HTMLAttributes<HTMLDivElement>
>(({ children, className, ...props }, ref) => {
  const isReorderableRegion = useIsReorderableRegion();
  return (
    <div
      className={cn(
        'text-left flex flex-col justify-center gap-1 h-full w-full',
        isReorderableRegion && 'ml-5',
        className,
      )}
      {...props}
      ref={ref}
    >
      {children}
    </div>
  );
});
